import _extends from "@babel/runtime/helpers/extends";
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import { Tag } from './tag';
import IconAdd from '../icon/IconAdd';
export function componentGenerator(Comp) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var className = props.className,
        style = props.style,
        list = props.list,
        type = props.type,
        _props$showAddButton = props.showAddButton,
        showAddButton = _props$showAddButton === void 0 ? true : _props$showAddButton,
        addArea = props.addArea,
        horizontalPadding = props.horizontalPadding,
        verticalPadding = props.verticalPadding,
        onAdd = props.onAdd,
        _onClose = props.onClose;
    var domRef = useRef(null);
    useImperativeHandle(ref, function () {
      return {
        dom: domRef.current
      };
    });

    function getTagStyle(tag, index) {
      var baseStyle = tag.style || {};
      var paddingStyle = index === list.length - 1 && !showAddButton ? {} : {
        marginRight: horizontalPadding
      };
      return _extends({}, baseStyle, paddingStyle, {
        marginBottom: verticalPadding
      });
    }

    function getListStyle() {
      var marginStyle = {};

      if (verticalPadding && typeof verticalPadding === 'string') {
        marginStyle = {
          marginBottom: "-" + verticalPadding
        };
      } else if (verticalPadding && typeof verticalPadding === 'number') {
        marginStyle = {
          marginBottom: -1 * verticalPadding
        };
      }

      return _extends({}, style || {}, marginStyle);
    }

    return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
      var prefixCls = _ref.prefixCls;
      var prefix = prefixCls + "-tag-list";
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefix, className),
        style: getListStyle(),
        ref: domRef
      }, list.map(function (tag, index) {
        return /*#__PURE__*/React.createElement(Comp, _extends({
          key: index
        }, tag, {
          style: getTagStyle(tag, index),
          type: type,
          onClose: function onClose(e) {
            tag.onClose && tag.onClose(e);
            _onClose && _onClose(index, e);
          }
        }));
      }), showAddButton ? /*#__PURE__*/React.createElement("div", {
        className: "tag-list-add-wrap",
        onClick: onAdd
      }, addArea !== void 0 ? addArea : /*#__PURE__*/React.createElement(Tag, {
        type: type,
        className: "tag-list-add",
        borderStyle: "dashed",
        icon: /*#__PURE__*/React.createElement(IconAdd, null),
        style: {
          marginBottom: verticalPadding
        }
      }, "\u6DFB\u52A0\u6807\u7B7E")) : null);
    });
  });
}